module.exports = __webpack_public_path__ + "img/home_title13.fa5b0139.png";